
import { ShowDialogProps } from '../../../../show-dialog'
import { MainButton } from 'src/components/MainButton'
import { GenericDialogLayout } from 'src/components/GenericDialogLayout'
import { Checkbox, FormControlLabel, Typography } from '@mui/material'
import { invalidateTaskCache, useDeleteTaskWithParams } from '../../../../api/tasks'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import { useState } from 'react'
import { invalidateTaskResourceCache } from 'src/api/task-resource'

interface TaskDeleteDialogProps extends ShowDialogProps {
  taskId: EntityId
  localityId: EntityId
  customerId: EntityId
  hasOngoingScheduledTasks: boolean
}

const TaskDeleteDialog = ({ pop, taskId, localityId, customerId, hasOngoingScheduledTasks }: TaskDeleteDialogProps) => {
  const { t } = useTranslation('task')
  const [keepScheduledTasks, setKeepScheduledTasks] = useState(false)
  const { mutateAsync } = useDeleteTaskWithParams(localityId, taskId)

  const handleConfirm = async () => {
    await mutateAsync(keepScheduledTasks, {
      onSuccess: () => {
        invalidateTaskCache.getCustomerAdminTaskByFilter(customerId)
        invalidateTaskCache.getCustomerAdminScheduleTaskByFilter(customerId)
        invalidateTaskCache.useGetFilterCalendarScheduleTask(customerId)
        invalidateTaskResourceCache.getRelatedTasks(customerId)
        toast.success(t('taskDeletedSuccessfully', { ns: 'task' }))
        pop(true)
      },
      onError: () => {
        toast.error(t('updatingError', { ns: 'common' }))
      },
    })
  }

  return (
    <GenericDialogLayout
      pop={pop}
      actions={[
        <MainButton key="accept" variant="contained" onClick={handleConfirm}>
          {t('yes', { ns: 'common' })}
        </MainButton>,
      ]}
      removedCloseButton={false}
    >
      <Typography sx={{ mb: 2 }}>{t('delete-task-description')}</Typography>
      {hasOngoingScheduledTasks && (
        <>
          <Typography color="text.secondary" sx={{ mb: 2 }}>{t('delete-task-scheduled-warning', { ns: 'task' })}</Typography>
          <FormControlLabel
            control={
              <Checkbox
                checked={keepScheduledTasks}
                onChange={e => setKeepScheduledTasks(e.target.checked)}
                color="primary"
              />
            }
            label={t('keep-scheduled-tasks', { ns: 'task' }) as string}
          />
        </>
      )}
    </GenericDialogLayout>
  )
}

export default TaskDeleteDialog